import { Grid } from "@material-ui/core";
import { TextField } from "mui-rff";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { productColorsActions } from "../../../actions/productColor.actions";

const formFields = [
  {
    mdSize: 12,
    xsSize: 12,
    field: <TextField label="Nom" name="name" margin="none" required />,
  },
  {
    mdSize: 12,
    xsSize: 12,
    field: <TextField label="RAL" name="ral" margin="none" />,
  }
];

export default function ColorsForm(props) {
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(productColorsActions.fetchProductColorsIfNeeded());
  }, [dispatch]);

  return (
    <Grid container alignItems="center" spacing={2}>
      <Grid item xs={12} md={8} container spacing={2}>
        {formFields.map((item, idx) => (
          <Grid
            className={"mb-4"}
            item
            md={item.mdSize}
            xs={item.xsSize}
            key={idx}
          >
            {item.field}
          </Grid>
        ))}
      </Grid>
    </Grid>
  );
}